import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, dark = false }) => (
  <span
    className={`inline-block text-sm uppercase tracking-[0.25em] font-bold mb-4 ${
      dark ? "text-lightblue" : "text-brand"
    }`}
  >
    <span className="text-gold">/ </span>
    {children}
  </span>
);
